export default __webpack_public_path__ + "media/music/704790b163432b3f39390716642d4cc5.mp3";